/* eslint max-len: 0 */
import React from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { useParams, Link } from 'react-router-dom'
import useSharedComposition from 'components/designSidepanel/useSharedComposition'

require('./SharedPage.scss')

const SharedPage = () => {
    const { compositionUuid } = useParams()
    const { t } = useTranslation()

    const { sharedCompositionData, error } = useSharedComposition(compositionUuid)
    const { name, publicCompositionImageUrl } = sharedCompositionData
    const compositionName = name || t('design.default composition name')
    if (error) {
        return (
            <div id="SharedPage">
                <div className="errMessage">
                    <div className="errHeader">{t('shared.not available')}</div>

                    <div className="errBody">
                        <Trans i18nKey="shared.errMessage">
                            Sorry, we can’t find the design you’re looking for. Find out more about{' '}
                            <Link to="/" className="linkPage">
                                decorating your own space
                            </Link>{' '}
                            or try{' '}
                            <Link to="/dashboard" className="linkPage">
                                decorating our showrooms
                            </Link>
                            .
                        </Trans>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div id="SharedPage">
            <div className="compositionName">{compositionName}</div>
            <img className="compositionImage" src={publicCompositionImageUrl} alt={t('shared.alt.shared design')} />
        </div>
    )
}

export default SharedPage
